import axios from "axios";
import { GURL } from "./global";

export const GetMessagingMediaFilesEntityId = (id: any) => {
  const url = `${GURL}/MessagingMedia/v1/MediumFile/GetFilesEntityId/${id}?id=${id}`;
  //console.log(url);
  return axios.get(url);
};

export const GetMessagingMediaFileById = (id: any) => {
  const url = `${GURL}/MessagingMedia/v1/MediumFile/GetFile/${id}?id=${id}`;
  //console.log(url);
  return axios.get(url, {
    responseType: "blob",
    headers: {
      Accept: "application/octet-stream",
    },
  });
};
